import chroma from "chroma-js";

export const primary = "#2e3440";
export const secondary = "#3B4253";

export const TextHeader = "#f3f3f3";

export const Text = "#b6c1d6";

export const separatorDark = chroma(primary).darken(0.5);
export const separatorLight = primary;

export const highLightPrimary = chroma(primary).brighten(0.5);
export const highLightSecondary = chroma(secondary).brighten(0.5);

export const shadow = chroma(primary).darken(0.7);

export const darkenSecondary = r => chroma(secondary).darken(r);
export const brightenSecondary = r => chroma(secondary).brighten(r);

export const darkenPrimary = r => chroma(primary).darken(r);

export const hoverPrimary = brightenSecondary(0.5);
export const hoverSecondary = darkenPrimary(0.5);



// WEBPACK FOOTER //
// ./src/reusable/colors.js